<template>
  <div>
    <header class="bar bar-nav">
      <h1 class='title'>评价晒单</h1>
    </header>

    <div class="list-block media-list" style="margin-top: 2rem">
      <ul>
        <li>
          <div class="item-content">
            <div class="item-media">
              <img :src="baseurl + merch.merchandiseIcon" style="width: 5rem;">
            </div>
            <div class="item-inner">
              <div class="item-title-row">
                <div class="item-title">评分</div>
              </div>
              <div id="starts">
                <span class="icon icon-star" rel="1" style="background-color: yellow"></span>
                <span class="icon icon-star" rel="2" style="background-color: yellow"></span>
                <span class="icon icon-star" rel="3" style="background-color: yellow"></span>
                <span class="icon icon-star" rel="4" style="background-color: yellow"></span>
                <span class="icon icon-star" rel="5" style="background-color: yellow"></span>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <ul>
        <li class="align-top">
          <div class="item-content">
            <div class="item-inner">
              <div class="item-input">
                <textarea id = 'text' placeholder="请评价~" ></textarea>
              </div>
            </div>
          </div>
        </li>
      </ul>
      <div class="content-block">
        <div class="button button-big button-fill button-danger" @click="commitComment">提交评价</div>
      </div>
    </div>

  </div>
</template>
<script>
  import $ from 'jquery'
  import {mapMutations} from 'vuex'
  export default {
    data () {
      return {
        baseurl: '/emktResources/resocurces/img/merchandise/',
        merch: JSON.parse(this.$route.query.merchandise),
        level: 5
      }
    },
    mounted () {
      var self = this
      $(function () {
        var s = document.getElementById('starts')
        var n = s.getElementsByTagName('span')

        for (var i = 0; i < n.length; i++) {
          n[i].onclick = function () {
            var q = +this.getAttribute('rel')
            self.level = q
            for (let i = q; i < n.length; i++) {
              n[i].style = ''
            }
            for (let i = 0; i < q; i++) {
              n[i].style = 'background-color: yellow'
            }
          }
        }
      })
    },
    methods: {
      ...mapMutations([
        'ADD_COMMENT_FROM_WAITCOMMENT'
      ]),
      commitComment () {
        var self = this
        let BOrderComment = {}
        BOrderComment.orderId = this.merch.orderId
        BOrderComment.MerchandiseGuid = this.merch.merchandiseId
        BOrderComment.comments = $('#text').val()
        BOrderComment.commentLevel = this.level

        this.gcapi('merchandiseComment', BOrderComment).then((response) => {
          if (response.body.code === 1) {
            $.toast(response.body.message)
            return
          }
          self.ADD_COMMENT_FROM_WAITCOMMENT(this.merch)
          $.toast('评价成功')
          self.$router.go(-1)
        })
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// CommentForOrder.vue?0fdc4d84